import { render, staticRenderFns } from "./media_holding_match_code.vue?vue&type=template&id=8f23762a&scoped=true"
import script from "./media_holding_match_code.vue?vue&type=script&lang=js"
export * from "./media_holding_match_code.vue?vue&type=script&lang=js"
import style0 from "./media_holding_match_code.vue?vue&type=style&index=0&id=8f23762a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f23762a",
  null
  
)

export default component.exports